import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

interface Props {
  property_id: string;
  name: string;
  parentName: string;
  offer_count: number;
  visit_count: number;
  visualization_text: string;
  visualization_count: number;
  parentUri?: string;
}

const HeaderCounters = ({
  property_id,
  name,
  parentName,
  parentUri,
  offer_count = 0,
  visit_count = 0,
  visualization_text = '',
  visualization_count = 0,
}: Props) => {
  if (!parentUri) {
    parentUri = '#';
  }
  const stats = [
    {
      label: 'Visitas',
      value: visit_count,
      href: `/properties/admin/${property_id}/admin-visit`,
      color: 'green',
      icon: 'ni ni-calendar-grid-58',
    },
    {
      label: 'Ofertas',
      value: offer_count,
      href: `/properties/admin/${property_id}/admin-offer`,
      color: 'orange',
      icon: 'ni ni-shop',
    },
    {
      label: `Visualizaciones ${visualization_text}`.trim(),
      value: visualization_count,
      href: `/properties/admin/${property_id}/views`,
      color: 'blue',
      icon: 'ni ni-chart-pie-35',
    },
  ];
  return (
    <>
      <div className="header header-dark bg-default pb-5 content__title content__title--calendar">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-3">
              <Col lg="6" xs="7">
                <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0">
                  {name}
                </h6>{' '}
                <Breadcrumb
                  className="d-none d-md-inline-block ml-lg-4"
                  listClassName="breadcrumb-links breadcrumb-dark"
                >
                  <BreadcrumbItem>
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      <i className="fas fa-home" />
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <a href={parentUri}>{parentName}</a>
                  </BreadcrumbItem>
                  <BreadcrumbItem aria-current="page" className="active">
                    {name}
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
            <Row>
              {stats.map(({ label, value, href, color, icon }) => (
                <Col lg="4" md="4" xs="12" key={label}>
                  <a href={href} className="d-block">
                    <div className="card card-stats mb-3">
                      <div className="card-body py-3">
                        <Row className="align-items-center">
                          <Col xs="auto">
                            <div
                              className={`icon icon-shape icon-sm bg-${color} text-white rounded-circle shadow`}
                            >
                              <i className={icon}></i>
                            </div>
                          </Col>
                          <div className="col">
                            <h5 className="card-title text-uppercase text-muted mb-0">
                              {label}
                            </h5>
                            <span className="h2 font-weight-bold mb-0">
                              {value}
                            </span>
                          </div>
                          <Col xs="auto" className="text-sm">
                            Ver detalle
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default HeaderCounters;
